const DAY_DURATION = 86400000
let isValidateDate = (v) => {
  return (v instanceof Date) && !isNaN(v.getTime())
}
// 判断是不是合法的日期输入,如果输入20201212 这种自动转成2020-12-12
let formatValidateDate = (v, isTimer) => {
  let _v = new Date(v)
  if (!isValidateDate(_v)) {
    try {
      v = v + ''
      // 如果非法 先都转换成统一格式
      v = v.replaceAll(' ', '').replaceAll('/', '').replaceAll('-', '').replaceAll(':', '')
      // 如果不是时间默认取前8位
      if (!isTimer) {
        v = v.substr(0, 8)
      } else {
        v = v.substr(0, 14)
      }
      // 日期
      _v = v.substr(0, 4) + '-' + v.substr(4, 2) + '-' + v.substr(6, 2)
      // 时间
      if (isTimer) {
        _v += ' '
        // 时间有可能漏了写了 补充上，补充上:
        _v += (v.substr(8, 2) || '00') + ':' + (v.substr(10, 2) || '00') + ':' + (v.substr(12, 2) || '00')
      }
      v = _v
      if (!isValidateDate(new Date(_v))) {
        return null
      } else {
        return v
      }
    } catch (e) {
      return null
    }
  } else {
    return v
  }
}
// 如果
export function setData (value, observable, isNumbericValue) {
  let v = formatValidateDate(value, this.isTimer)
  let curDateValue = (v ? new Date(v) : new Date()).toDateString()
  let oldDateValue = isNumbericValue ? observable() - 0 : observable()
  oldDateValue = new Date(oldDateValue).toDateString()
  // 如果不是timer 则只比较日期是否一样不比较时间，
  if (!this.isTimer && curDateValue === oldDateValue) {
    return ''
  } else {
    if (v && isNumbericValue) {
      v = new Date(v).getTime()
    }
    observable(v)
  }
}
// 获取每个月的第一天
export function getFirstDayOfMonth (date) {
  const temp = new Date(date.getTime())
  temp.setDate(1)
  return temp.getDay()
}
// 获取每个月的天数
export function getDayCountOfMonth (year, month) {
  if (month === 3 || month === 5 || month === 8 || month === 10) {
    return 30
  }
  if (month === 1) {
    // 计算闰年
    if ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0) {
      return 29
    } else {
      return 28
    }
  }

  return 31
}

export function getWeekNumber (src) {
  const date = new Date(src.getTime())
  date.setHours(0, 0, 0, 0)
  // Thursday in current week decides the year.
  date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7)
  // January 4 is always in week 1.
  const week1 = new Date(date.getFullYear(), 0, 4)
  // Adjust to Thursday in week 1 and count number of weeks from date to week 1.
  return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7)
}

export function getStartDateOfMonth (year, month) {
  const result = new Date(year, month - 1, 1)
  const day = result.getDay()

  if (day === 0) {
    result.setTime(result.getTime() - DAY_DURATION * 7)
  } else {
    result.setTime(result.getTime() - DAY_DURATION * day)
  }
  return result
}



// WEBPACK FOOTER //
// ./src/components/datepicker/util/index.js